import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import Node from './Node';

const BoxTimeline = ({ nodes, currentStep, isMobile }) => (
  <div className="box-timeline">
    {nodes
      && nodes.map((node, index) => {
        const activeStepIndex = nodes.findIndex((x) => x.label === currentStep);
        let nodeStatus = index < activeStepIndex ? 'past' : '';
        nodeStatus = index === activeStepIndex ? 'active' : nodeStatus;
        const data = { message: node.label, status: nodeStatus };
        return (
          <div
            key={node.label}
            className={isMobile ? 'challenge-timeline__node-box' : 'challenge-timeline__node-box-desktop'}
          >
            <Node data={data} isBoxNode isMobile={isMobile} />
            {index < nodes.length - 1 && (
              <div
                className={
                  cx(
                    isMobile ? 'challenge-timeline__node-box__line' : 'challenge-timeline__node-box__line-desktop',
                    { solid: index < activeStepIndex && 'solid' },
                  )
                }
              />
            )}
          </div>
        );
      })}
  </div>
);

BoxTimeline.defaultProps = {
  nodes: [],
  currentStep: '',
  isMobile: true,
};

BoxTimeline.propTypes = {
  nodes: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      message: PropTypes.string,
      order: PropTypes.number,
    }),
  ),
  currentStep: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default BoxTimeline;
